module.exports = __webpack_public_path__ + "img/mob-menu-wa.571fa2b7.svg";